<p class='blue-label'><ng-content></ng-content></p>
